import { useDuplicateProgramMutation } from "../store";

export const useProgramService = () => {
  const [duplicateProgramRpc] = useDuplicateProgramMutation();

  // Duplica un programa completo en UNA sola llamada al RPC server-side
  // `duplicate_program` (a través del proxy autenticado), en lugar de la antigua
  // ráfaga de ~40 peticiones (getProgram + createProgram + por cada workout:
  // getWorkout/createWorkout + N createWorkoutExercise + N createSetObjective).
  // Esa ráfaga provocaba 401 intermitentes (rate-limit de /userinfo en el proxy)
  // y copias parciales/corruptas. El RPC es atómico y la propiedad del programa
  // origen la verifica el proxy.
  const duplicateProgram = async (programId, nameNewProgram, refetch) => {
    try {
      const data = await duplicateProgramRpc({
        programId,
        newName: nameNewProgram,
      }).unwrap();
      if (!data?.success) {
        throw new Error(data?.error || 'No se pudo duplicar el programa');
      }
      if (refetch) refetch();
      return data;
    } catch (error) {
      console.error('Error al duplicar el programa:', error);
      throw error;
    }
  };

  return {
    duplicateProgram,
  };
};
